module.exports = __webpack_public_path__ + "../static/img/integrations_mini.8914d459.png";